import { render, staticRenderFns } from "./salesReturnHistories.vue?vue&type=template&id=c9f7d38a&scoped=true&"
import script from "./salesReturnHistories.vue?vue&type=script&lang=js&"
export * from "./salesReturnHistories.vue?vue&type=script&lang=js&"
import style0 from "./salesReturnHistories.vue?vue&type=style&index=0&id=c9f7d38a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f7d38a",
  null
  
)

component.options.__file = "salesReturnHistories.vue"
export default component.exports